import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportCrowdCellConfig } from '@api/manageCrowdCells';

import { IGetCrowdCellConfigDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

import { ESnackbarTypes } from '@enums/common';

import { DOWNLOAD_CROWDCELL_CONFIG } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportCrowdCellConfig = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleDownloadCrowdCellConfig,
		isLoading: isLoadingDownloadCrowdCellConfig,
	} = useMutation<IGetCrowdCellConfigDTO>({
		mutationKey: [DOWNLOAD_CROWDCELL_CONFIG],
		mutationFn: exportCrowdCellConfig,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.exportCrowdCellConfigSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		handleDownloadCrowdCellConfig,
		isLoadingDownloadCrowdCellConfig,
	};
};
